var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeOrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2715 6.33972L18.9545 8.02263L20.5826 6.39456C21.1391 5.83804 21.1391 4.92767 20.5826 4.37115L19.6288 3.41739C19.0723 2.86087 18.1619 2.86087 17.6053 3.41739L4.8637 16.1592C4.65816 16.3647 4.50222 16.6146 4.40779 16.8898L3 21L7.10987 19.5922C7.38504 19.4978 7.63493 19.3419 7.84047 19.1363L17.664 9.31307M5.84896 17.7696L7.40745 19.3285",
    stroke: "#85909F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeOrg);
export default __webpack_public_path__ + "static/media/changeOrg.a14bf8a28c49097d86f4fb5f64d216c4.svg";
export { ForwardRef as ReactComponent };